import React, { Component } from 'react';

import _ from 'lodash';

import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

import { DateRangePicker } from 'react-dates';

import 'react-dates/lib/css/_datepicker.css';

import utils from 'Utils/index.js';
import style from './style.scss';


export default class StatisticsFilter extends Component {

  constructor(props) {
    super(props);

    const {app_data, filter_data} = props;

    this.state = {
      ...filter_data,

      focusedInput: null
    };

    this.dateChange = this.dateChange.bind(this);

    this.onFilterChange = this.onFilterChange.bind(this);

  }

  dateChange({startDate, endDate}) {

    const start_date = startDate ? startDate.clone().startOf('day') : null;
    const end_date = endDate ? endDate.clone().endOf('day') : null;




    this.setState({
      start_date: start_date,
      end_date: end_date,
    });

  }

  

  onFilterChange() {
    const {onFilterChange} = this.props;

    onFilterChange(_.assign({}, this.state));
  }

  componentDidMount(){
    this.onFilterChange();
  }

  render() {

    let {app_data: {device_types, problem_types, statuses}, onFilter, minDate} = this.props;

    const ranges = [
      { id: 'today', range: { startDate: moment(), endDate: moment() }, label: 'Сегодня' },
      { id: '7_days', range: { startDate: moment().subtract(7, 'days'), endDate: moment() }, label: 'Последние 7 дней' },
      { id: '1_month', range: { startDate: moment().subtract(1, 'month'), endDate: moment() }, label: 'Последний месяц' },
      { id: '2_months', range: { startDate: moment().subtract(2, 'months'), endDate: moment() }, label: 'Последние 2 месяца' },
    ];

    const {start_date, end_date} = this.state;
    console.log(minDate)
    return (
      <div>

        <div className="statistics_filter">

          <div className="statistics_filter__row">

            <div className="layout__col_3">

              <div className="form__label">Дата</div>

              <div className="form__control">

                <DateRangePicker
                  startDate={start_date} // momentPropTypes.momentObj or null,
                  startDateId="start_date" // PropTypes.string.isRequired,
                  endDate={end_date} // momentPropTypes.momentObj or null,
                  endDateId="end_date" // PropTypes.string.isRequired,
                  onDatesChange={this.dateChange} // PropTypes.func.isRequired,
                  focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                  onFocusChange={focusedInput => {
                    this.setState({ focusedInput })
                  }} // PropTypes.func.isRequired,
                  isOutsideRange={(date) =>!minDate ? false : date.isBefore(minDate) /* allow future & past dates */}
                  minimumNights={0}
                  minDate={minDate}
                />

              </div>

            </div>

          </div>


          <div className="layout__row">




            <div className="layout__col_6">
              <div className="button button_green button_big statistics_filter__button" onClick={this.onFilterChange}>
                Применить
              </div>
            </div>

          </div>


        </div>



      </div>
    )
  }

}


